import React from 'react';
import { twMerge } from 'tailwind-merge';
import classnames from 'classnames';
import { CustomSwitch } from 'components';
import { EditIconBlue } from 'assets/icons';
import { ReminderConfig } from 'components/reminder-modal/types';
import { formatReminderText } from 'containers/settings/utils';
import { ReminderDateTypeLabel } from 'containers/settings/constants';

interface PaymentRemindersSettingSectionProps {
  reminders: ReminderConfig[];
  isEnabled: boolean;
  onToggle: () => void;
  isDisabled?: boolean;
  onOpenModal: () => void;
}

const PaymentRemindersSettingSection: React.FC<PaymentRemindersSettingSectionProps> = ({
  reminders,
  isEnabled,
  onToggle,
  isDisabled = false,
  onOpenModal
}) => {
  return (
    <div
      className={twMerge(
        classnames({
          'pointer-events-none opacity-50': isDisabled
        })
      )}>
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <div className="text-xl font-bold text-primaryText">Payment reminders</div>
          <div className="mt-2 text-17px font-normal text-primaryText">
            Set your default reminder schedule, you can modify it for individual invoices anytime.
          </div>
        </div>
        <div className="ml-6">
          <CustomSwitch enabled={isEnabled} toggleSwitch={onToggle} id="payment-reminders-switch" />
        </div>
      </div>

      {isEnabled && (
        <div className="mt-3 rounded-md border border-borderGray bg-white p-4 shadow-sm md:w-[500px] lg:w-[600px]">
          {reminders.length > 0 ? (
            <div className="divide-y">
              {reminders.map((reminder, index) => (
                <div key={`reminder-${reminder.id}-${index}`} className="flex items-center justify-between py-3">
                  <div className="flex-1">
                    <span className="text-17px font-semibold text-primaryText">Reminder {reminder.reminderNumber}</span>
                  </div>
                  <div className="flex-1 text-right">
                    <span className="text-17px font-medium text-accentText">
                      {formatReminderText(reminder, ReminderDateTypeLabel.DUE_DATE)}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="py-4 text-center">
              <span className="text-sm text-accentText">No reminders configured</span>
            </div>
          )}

          <div className="mt-2 flex items-center justify-end">
            <EditIconBlue className="h-[18px] w-[18px]" />
            <button
              onClick={onOpenModal}
              className="ml-1 text-17px font-semibold text-secondary hover:text-secondary/80"
              disabled={isDisabled}>
              {reminders?.length > 0 ? 'Edit reminders' : 'Add reminders'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentRemindersSettingSection;
